(() => {
  function normaliseWebsite(value) {
    const raw = value.trim();
    if (!raw) return '';
    if (/\s/.test(raw) || (/^[a-z][a-z\d+.-]*:\/\//i.test(raw) && !/^https?:\/\//i.test(raw))) return null;
    try {
      const url = new URL(/^https?:\/\//i.test(raw) ? raw : 'https://' + raw);
      const host = /^(?:[a-z\d](?:[a-z\d-]*[a-z\d])?\.)+[a-z\d](?:[a-z\d-]*[a-z\d])?$/i;
      if (!['http:', 'https:'].includes(url.protocol) || !host.test(url.hostname) || url.username || url.password) return null;
      return url.href;
    } catch {
      return null;
    }
  }

  function normalisePhone(value, dial, prefix) {
    let raw = value.trim();
    if (!raw) return '';
    const extension = raw.match(/\s*(?:ext\.?|extension|x|#)\s*(\d+)\s*$/i);
    if (extension) raw = raw.slice(0, extension.index).trim();
    if (!/^(?:\+|00)?[\d\s().-]+$/.test(raw)) return null;
    const international = /^(?:\+|00)/.test(raw);
    const compact = raw.replace(/[\s.-]/g, '');
    if (international && prefix === '0' && (compact.startsWith('+' + dial) || compact.startsWith('00' + dial))) raw = raw.replace(/\(0\)/, '');
    let digits = raw.replace(/\D/g, '');
    if (international) {
      if (raw.startsWith('00')) digits = digits.slice(2);
    } else {
      if (prefix && digits.startsWith(prefix) && digits.length - prefix.length >= 4) digits = digits.slice(prefix.length);
      digits = dial + digits;
    }
    if (digits.length > 15 || digits.length < dial.length + 3) return null;
    return '+' + digits + (extension ? ' ext. ' + extension[1] : '');
  }

  function passwordError(password, confirmation, message) {
    return confirmation && confirmation !== password ? message : '';
  }

  function init(scope) {
    scope.querySelectorAll('[data-ufi-application]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const get = id => root.querySelector('#ufi-' + id);
      const mappings = {
        ship: {company:'company',address:'address',city:'city',province:'province',postcode:'postcode',country:'country',first:'first',last:'last',email:'email',phone:'phone','phone-code':'phone-code',job:'job'},
        acc: {address:'address',city:'city',province:'province',postcode:'postcode',country:'country',first:'first',last:'last',email:'email',phone:'phone','phone-code':'phone-code',job:'job'}
      };
      const drafts = {ship:{},acc:{}};
      const phones = Array.from(root.querySelectorAll('[data-ufi-phone]'));
      const website = get('website');
      const password = get('password');
      const confirmation = get('password-confirm');
      phones.forEach(group => {
        const input = group.querySelector('[data-phone-number]');
        group.querySelector('[data-phone-value]').name = input.name;
        input.removeAttribute('name');
      });
      get('acc_address_note').name = get('acc_address').name;
      get('acc_address').removeAttribute('name');
      const address = prefix => ['address','city','province','postcode'].map(id => get(prefix + id)?.value.trim()).filter(Boolean).concat(get(prefix + 'country')?.value ? [get(prefix + 'country').selectedOptions[0].textContent.trim()] : []).join(', ');

      function copy(prefix) {
        Object.entries(mappings[prefix]).forEach(([to,from]) => {
          const target = get(prefix + '_' + to);
          if (target) target.value = get(from)?.value || '';
        });
      }

      function syncPhone(group) {
        const select = group.querySelector('[data-phone-code]');
        const code = select.selectedOptions[0];
        const input = group.querySelector('[data-phone-number]');
        const value = normalisePhone(input.value, code.dataset.dial, code.dataset.prefix);
        input.setCustomValidity(value === null ? input.dataset.invalidMessage : '');
        group.querySelector('[data-phone-value]').value = value || '';
        select.dataset.previousDial = code.dataset.dial;
      }

      function syncWebsite(normalise) {
        const value = normaliseWebsite(website.value);
        website.setCustomValidity(value === null ? website.dataset.invalidMessage : '');
        if (normalise && value !== null) website.value = value;
      }

      function syncPassword() {
        confirmation.setCustomValidity(passwordError(password.value, confirmation.value, confirmation.dataset.mismatchMessage));
      }

      function sync() {
        root.querySelectorAll('[data-copy]:checked').forEach(box => copy(box.dataset.copy));
        phones.forEach(syncPhone);
        get('acc_address_note').value = address('acc_');
        get('marketing-note').value = get('marketing').checked ? 'Yes' : 'No';
        get('reg-country-name').value = get('country').value ? get('country').selectedOptions[0].textContent.trim() : '';
        get('ship-contact').value = [get('ship_first').value,get('ship_last').value].filter(Boolean).join(' ');
        syncWebsite(false);
        syncPassword();
      }

      phones.forEach(group => {
        const select = group.querySelector('[data-phone-code]');
        const input = group.querySelector('[data-phone-number]');
        input.addEventListener('blur', () => {
          const raw = input.value.trim();
          if (/^(?:\+|00)/.test(raw)) {
            let digits = raw.replace(/\D/g, '');
            if (raw.startsWith('00')) digits = digits.slice(2);
            const current = select.selectedOptions[0];
            const match = digits.startsWith(current.dataset.dial) ? current : Array.from(select.options).sort((a,b) => b.dataset.dial.length - a.dataset.dial.length).find(option => digits.startsWith(option.dataset.dial));
            if (match) select.value = match.value;
          }
          sync();
        });
        select.addEventListener('change', () => {
          const raw = input.value.trim();
          if (/^(?:\+|00)/.test(raw)) {
            const previousDial = select.dataset.previousDial;
            const prefix = raw.startsWith('00') ? '00' + previousDial : '+' + previousDial;
            const compact = raw.replace(/[\s().-]/g, '');
            if (compact.startsWith(prefix)) input.value = compact.slice(prefix.length);
          }
          sync();
        });
      });

      root.querySelectorAll('[data-copy]').forEach(box => {
        const prefix = box.dataset.copy;
        const fields = root.querySelector('[data-copy-fields="' + prefix + '"]');
        const help = root.querySelector('[data-copy-help="' + prefix + '"]');
        function update() {
          fields.hidden = box.checked;
          help.hidden = !box.checked;
          box.setAttribute('aria-expanded',String(!box.checked));
          if (box.checked) copy(prefix);
        }
        box.addEventListener('change',() => {
          if (box.checked) fields.querySelectorAll('input,select,textarea').forEach(el => drafts[prefix][el.id] = el.value);
          else fields.querySelectorAll('input,select,textarea').forEach(el => el.value = drafts[prefix][el.id] ?? (el.matches('[data-phone-code]') ? 'GB' : ''));
          update(); sync();
        });
        update();
      });
      website.addEventListener('blur', () => { syncWebsite(true); });
      form.addEventListener('input',sync);
      form.addEventListener('change',sync);
      form.addEventListener('submit',event => {
        form.querySelectorAll('[required]').forEach(el => {
          if (el.type !== 'password' && el.type !== 'checkbox') el.value = el.value.trim();
        });
        sync();
        syncWebsite(true);
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
      });
      sync();
    });
    scope.querySelectorAll('[data-ufi-login]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      function view() {
        const recover = root.querySelector('#recover');
        const recovering = location.hash === '#recover' || (!location.hash && Boolean(recover.querySelector('[role="alert"],[role="status"]')));
        recover.hidden = !recovering;
        root.querySelector('#login').hidden = recovering;
        recover.style.display = recovering ? 'block' : 'none';
        root.querySelector('#login').style.display = recovering ? 'none' : 'block';
      }
      window.addEventListener('hashchange',() => { view(); root.querySelector(location.hash === '#recover' ? '#recover' : '#login').focus(); });
      view();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

